<p-dialog [(visible)]="visible" [modal]="true" [draggable]="false" [style]="{width: '600px'}" (onHide)="handleHideDocumentStatus()">
	<ng-template pTemplate="header">
		<div class="partner-settings-documents-updated-header">Your update was submitted</div>
	</ng-template>

	<div>
		<div class="flex flex-row" style="margin-bottom: 40px;">
			<div class="partner-settings-documents-status-field-margin">
				<div class="partner-settings-legal-documents-status-darkblue"></div>
				<div class="partner-settings-documents-status-label">We have received your update</div>
			</div>
			<div class="partner-settings-documents-status-field-margin">
				<div class="partner-settings-legal-documents-status-field" [ngClass]="{
                        'partner-settings-legal-documents-status-darkblue': document.StatusId === documentStatusEnum.UnderReview || document.StatusId === documentStatusEnum.Approved}"></div>
				<div *ngIf="document.StatusId === documentStatusEnum.UnderReview || document.StatusId === documentStatusEnum.Approved" class="partner-settings-documents-status-label">Working on it</div>
			</div>
			<div>
				<div class="partner-settings-legal-documents-status-field" [ngClass]="{
                        'partner-settings-legal-documents-status-darkblue': document.StatusId === documentStatusEnum.Approved}"></div>
				<div *ngIf="document.StatusId === documentStatusEnum.Approved" class="partner-settings-documents-status-label">Update Approved!</div>
			</div>
		</div>
		<div class="partner-settings-documents-updated-label">Updated Legal Document</div>
		<div>
			Business Legal Document - 
			{{activeDocumentItem === documentTypeEnum.SECDocument ? 'SEC Document' : ''}}
			{{activeDocumentItem === documentTypeEnum.BIR2303 ? 'BIR 2303' : ''}}
			{{activeDocumentItem === documentTypeEnum.BusinessPermit ? 'Business Permit' : ''}}
		</div>
		<div class="flex flex-row">
			<div>
				<div class="partner-settings-documents-updated-field">
					<div class="partner-settings-documents-updated-field-label">Issue Date</div>
					<div class="partner-settings-documents-updated-field-value">{{document.IssueDateStr}}</div>
				</div>
				<div class="partner-settings-documents-updated-field" *ngIf="activeDocumentItem !== documentTypeEnum.SECDocument">
					<div class="partner-settings-documents-updated-field-label">Expiration Date</div>
					<div class="partner-settings-documents-updated-field-value">{{document.ExpiredDateStr}}</div>
				</div>
				<div class="partner-settings-documents-updated-field">
					<div class="partner-settings-documents-updated-field-label">Document number</div>
					<div class="partner-settings-documents-updated-field-value">{{document.DocumentNumber}}</div>
				</div>
			</div>
			<div style="margin-left: auto; margin-right: 30px" *ngIf="document.DocumentImageUrl">
				<p-image [src]="document.DocumentImageUrl" alt="Image" width="250" [preview]="true"></p-image>
			</div>
		</div>
	</div>

</p-dialog>